import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import visionImage from '@/assets/vision-lightbulb.png';

export const Vision = () => {
  const { t } = useTranslation();

  return (
    <section id="vision" className="py-24 lg:py-32 bg-background relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start relative pb-4 pl-4">
          <div
            className="absolute top-0 w-px pointer-events-none"
            style={{
              left: '0px',
              bottom: '15px',
              background: 'linear-gradient(to bottom, transparent 0%, hsl(290 46% 49%) 40%, hsl(290 46% 49%) 100%)',
            }}
          />
          <svg
            className="absolute pointer-events-none"
            style={{ bottom: '-0.5px', left: '-0.5px', width: '16px', height: '16px' }}
            viewBox="0 0 16 16"
            fill="none"
          >
            <line x1="0.5" y1="0" x2="16" y2="15.5" stroke="hsl(290 46% 49%)" strokeWidth="1" />
          </svg>
          <div
            className="absolute bottom-0 right-0 h-px pointer-events-none"
            style={{
              left: '14px',
              background: 'linear-gradient(to right, hsl(290 46% 49%) 0%, hsl(290 46% 49%) 60%, transparent 100%)',
            }}
          />

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1 }}
            className="relative"
          >
            <div className="flex items-center justify-center h-[500px] lg:h-[600px]">
              <motion.img
                src={visionImage}
                alt="Vision lightbulb illustration"
                className="w-56 md:w-64 lg:w-72 object-contain"
                animate={{ y: [0, -20, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <div className="flex items-center gap-4 text-4xl md:text-5xl lg:text-6xl font-black uppercase leading-tight mb-8 text-foreground">
              <img src="/title-icon.png" alt="" className="w-8 h-8 md:w-10 md:h-10" />
              {t('vision.label')}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              <p className="text-primary text-lg md:text-xl font-semibold leading-relaxed">
                {t('vision.text')}
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
